import { Button, Checkbox, TableCell, TableRow, MenuItem } from '@mui/material'
import React, { useState } from 'react'
import { formatCurrency } from '../../../utils/helpers'
import { FaFileInvoice, FaPrint, FaEye, FaFilePdf, FaFileImport } from 'react-icons/fa'
import { useDispatch } from 'react-redux'
import useAlert from '../../../hooks/useAlert'
import { InvoiceRecordTypeLabels } from '../../../utils/constants'
import { InvoicesUpdatePopUpModal } from './InvoiceComponents/InvoicesUpdatePopUpModal'
import InvoicePreviewPopUpModal from './InvoiceComponents/InvoicePreviewPopUpModal'
import InvoiceStatusPopUpModel from './InvoiceComponents/InvoiceStatusPopUpModel'
import InvoiceSendMarketPlaces from './InvoiceComponents/InvoiceSendMarketPlaces'
import { AiOutlinePartition } from 'react-icons/ai'
import { InvoiceSend } from './InvoiceComponents/InvoiceSend'
import { Edit, Info, Send, Storefront, DeleteOutline } from '@mui/icons-material';
import { FiEye } from 'react-icons/fi';
import invoiceService from '../../../services/invoicesService'
 
const Invoice = ({ itemToRender: invoice, handleViewMoreClick, handleSelect, isSelected }) => {
  const [openDialogPreview, setOpenDialogPreview] = useState(false);
  const [openDialogUpdate, setOpenDialogUpdate] = useState(false);
  const [openDialogSend, setOpenDialogSend] = useState(false);
  const [openDialogStatus, setOpenDialogStatus] = useState(false);
  const [openDialogMarketPlace, setOpenDialogMarketPlace] = useState(false);
    const { showSuccessAlertInvoice, showErrorAlertAll } = useAlert();
  
   const dispatch = useDispatch();
  const handlePreviewInvoice = () => {
    setOpenDialogPreview(true);
  };
  const handleUpdateModal = () => {
    setOpenDialogUpdate(true);
  };
  const handleSendModal = () => {
    setOpenDialogSend(true);
  };

  const handleStatusModal = () => {
    setOpenDialogStatus(true);
  };

  const handleMarketPlaceModal = () => {
    setOpenDialogMarketPlace(true);
  };

  const buttonHoverStyle = {
    backgroundColor: 'rgb(99, 102, 241)',
    color: 'white',
    transform: 'translateY(-1px)',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  };


  const buttonBaseStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px',
    padding: '6px',
    borderRadius: '6px',
    border: '1px solid',
    borderColor: 'rgb(99, 102, 241)',
    backgroundColor: 'white',
    color: 'rgb(99, 102, 241)',
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    margin: '0 2px'
  };

  const buttonDeleteStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '32px',
    height: '32px',
    padding: '6px',
    borderRadius: '6px',
    border: '1px solid',
    borderColor: 'rgb(220, 38, 38)',
    backgroundColor: 'white',
    cursor: 'pointer',
    color: 'rgb(220, 38, 38)',
    transition: 'all 0.2s ease-in-out',
    margin: '0 2px'
  };


  const buttonDeleteHoverStyle = {
    backgroundColor: 'rgb(220, 38, 38)',
    color: 'white',
    transform: 'translateY(-1px)',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
  };


  const MarketPlaceTypes = {
    1: "Trendyol",
    2: "Hepsiburada",
    3: "Amazon",
    4: "N11",
    5: "GittiGidiyor",
    6: "Çiçeksepeti",
    7: "Aliexpress",
    8: "Ebay",
    9: "Ptt",
    10: "Pazarama"
  };

  const StoreTypes = {
    1: "Gerçek mağza",
    2: "Diğer"
  };
  const invoiceStatusDescriptions = {
    0: "Hazır",
    1: "İşleniyor",
    1: "Kuyrukta",
    2: "İmzalandı",
    3: "İndirildi",
    4: "Pazaryerine Gönderildi",
    9: "Hata",
  };
  const getInvoiceStatusDescription = (status) => {
    return invoiceStatusDescriptions[status] || "Bilinmeyen Durum";
  };

  const deleteInvoice = async () => {
    const isConfirmed = confirm("Bu fatura silinecek, onaylıyor musunuz?" + invoice.id);
    if (isConfirmed) {
       try {
         var response = await invoiceService.deleteInvoice(invoice.id);
          if(response.status == true)
        {
          showSuccessAlertInvoice();
        }else{
           showErrorAlertAll();
        }        
      } catch (error) {
         showErrorAlertAll();
      }
    }
  };
 
  return (

    <TableRow key={invoice.invoiceNumber}>
      <TableCell>
        <Checkbox
          checked={isSelected}
          onChange={handleSelect}
          sx={{
            '&.Mui-checked': { color: '#1F1B45' }
          }}
        />
      </TableCell>
      <TableCell>{invoice.order?.orderNumber || "Manuel fatura"}</TableCell>
      <TableCell>{invoice.number}</TableCell>
      <TableCell>{new Date(invoice.createDate).toLocaleDateString()}</TableCell>
      <TableCell>{`${invoice?.invoiceCustomer?.name != null ? invoice.invoiceCustomer?.name : invoice.order?.customerFirstName + " " + invoice.order?.customerLastName}`}</TableCell>

      <TableCell>
        {
          invoice.order?.marketPlace || invoice.order?.ecommercePlace ?
            <div className="flex items-center">
              <img
                src={invoice.order?.marketPlace?.iconLink || invoice.order?.ecommercePlace?.iconLink}
                alt="Marketplace Icon"
                referrerPolicy="no-referrer"
                style={{
                  width: 40,
                  height: 40,
                  borderRadius: '8px',
                  objectFit: 'cover',
                  boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                }}
              />
            </div> : null
        }

      </TableCell>
      <TableCell>{invoice.totalAmount}</TableCell>
      <TableCell>{invoice.currencyCode}</TableCell>
      <TableCell>{getInvoiceStatusDescription(invoice.status)}</TableCell>
      <TableCell>
        {
          invoice.link ?
            <a
              href={invoice.link}
              target="_blank"
              rel="noopener noreferrer"
              title={invoice.link}
              className="block p-2 text-blue-500 hover:text-blue-700 transition-colors cursor-pointer"
            >
              <FiEye size={20} />
            </a>
            : null
        }

      </TableCell>
      <TableCell sx={{ padding: '8px' }}>
        {/* <button
          className="hover:bg-indigo-600 hover:text-white"
          style={buttonBaseStyle}
          onMouseOver={e => Object.assign(e.currentTarget.style, buttonHoverStyle)}
          onMouseOut={e => Object.assign(e.currentTarget.style, buttonBaseStyle)}
          onClick={handleUpdateModal}
          title=" Fatura Düzenle"
        >
          <Edit fontSize="small" />
        </button> */}
        <button
          className="hover:bg-indigo-600 hover:text-white"
          style={buttonBaseStyle}
          onMouseOver={e => Object.assign(e.currentTarget.style, buttonHoverStyle)}
          onMouseOut={e => Object.assign(e.currentTarget.style, buttonBaseStyle)}
          onClick={handleSendModal}
          title=" Fatura Aktar"
        >
          <Send fontSize="small" />
        </button>

        <button
          className="hover:bg-indigo-600 hover:text-white"
          style={buttonBaseStyle}
          onMouseOver={e => Object.assign(e.currentTarget.style, buttonHoverStyle)}
          onMouseOut={e => Object.assign(e.currentTarget.style, buttonBaseStyle)}
          title="Fatura Durumu"
          onClick={handleStatusModal}
        >
          <Info fontSize="small" />
        </button>

        <button
          className="hover:bg-indigo-600 hover:text-white"
          style={buttonBaseStyle}
          onMouseOver={e => Object.assign(e.currentTarget.style, buttonHoverStyle)}
          onMouseOut={e => Object.assign(e.currentTarget.style, buttonBaseStyle)}
          onClick={handleMarketPlaceModal}
          title="Pazaryerine Aktar"
        >
          <Storefront fontSize="small" />
        </button>


        <button
          className="hover:bg-indigo-600 hover:text-white"
          style={buttonDeleteStyle}
          onMouseOver={e => Object.assign(e.currentTarget.style, buttonDeleteHoverStyle)}
          onMouseOut={e => Object.assign(e.currentTarget.style, buttonDeleteStyle)}
          onClick={deleteInvoice}
          title="Sil"
        >
          <DeleteOutline fontSize="small" />
        </button>


      </TableCell>
      {/* önizleme alanı */}
      <InvoicePreviewPopUpModal
        openDialog={openDialogPreview}
        handleCloseDialog={() => setOpenDialogPreview(false)}
        invoiceData={invoice}
      />
      {/* gücelleme alanı */}
      <InvoicesUpdatePopUpModal
        openDialog={openDialogUpdate}
        handleCloseDialog={() => setOpenDialogUpdate(false)}
        data={invoice}
      />
      <InvoiceSend
        openDialog={openDialogSend}
        handleCloseDialog={() => setOpenDialogSend(false)}
        data={invoice}
      />
      <InvoiceStatusPopUpModel
        openDialog={openDialogStatus}
        handleCloseDialog={() => setOpenDialogStatus(false)}
        data={invoice}
      />
      <InvoiceSendMarketPlaces
        openDialog={openDialogMarketPlace}
        handleCloseDialog={() => setOpenDialogMarketPlace(false)}
        data={invoice}
      />
    </TableRow>
  )
}


export default Invoice;
